namespace GeniuzPOS.ReportMasterData {
    export class Report_1201_DiscColumns {
        static columnsKey = 'ReportMasterData.Report_1201_Disc';
    }
}
